import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumbs as MuiBreadcrumbs, } from '@mui/material';
import { useIsDesktop } from '../../../hooks';
import { styled } from '../../utils';
import { Icon } from '../Icon';
export function Breadcrumbs({ truncate, ...props }) {
    const isDesktop = useIsDesktop();
    return (_jsx(BreadcrumbsStyled, { maxItems: isDesktop ? undefined : 2, separator: _jsx(BreadrumbsIconStyled, { variant: "arrow-right-2", color: "inherit" }), ...props }));
}
const BreadcrumbsStyled = styled(MuiBreadcrumbs, {
    shouldForwardProp: (prop) => prop !== 'truncate',
})(({ theme, truncate }) => ({
    '& .MuiBreadcrumbs-separator': {
        color: theme.palette.grey[700],
        margin: theme.spacing(0, 0.5),
        display: truncate ? 'inline' : '',
    },
    '&	.MuiBreadcrumbs-ol': truncate
        ? {
            display: 'block',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        }
        : {},
    '& 	.MuiBreadcrumbs-li': {
        display: truncate ? 'inline' : '',
        '& > p, > a, > span': {
            display: truncate ? 'inline' : '',
            fontSize: '0.875rem',
            color: theme.palette.grey[700],
        },
    },
    '& 	.MuiButtonBase-root': {
        backgroundColor: theme.palette.background.default,
        margin: '0',
    },
}));
const BreadrumbsIconStyled = styled(Icon)(() => ({
    fontSize: '0.75rem',
}));
